import { defineFcm } from '../shared/factory';

export const FCM_SUPPORTER_SHARE_VISUALS = defineFcm('supporter_share_visuals')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-front-end',
		context: 'Supporter share visuals',
		description: 'Feature flag that enables the share visuals for supporters on the petition page',
		import: false,
	});
